





















































import Vue from "vue";
import { Component } from "vue-property-decorator";
import { ICompany } from "../api/company.interface";
import UploadButton from "@/shared/UploadButton.vue";
import { CompanyEventBus, ADD_EDIT_COMPANY } from "../api/company.event";

@Component({
  name: "companyDialog",
  components: {
    UploadButton
  }
})
export default class CompanyDialog extends Vue {
  company: ICompany = {} as ICompany;
  show: boolean = false;
  valid: boolean = false;
  loading: boolean = false;

  $refs: {
    form: any;
  };

  mounted() {
    CompanyEventBus.$on(ADD_EDIT_COMPANY, (payLoad: ICompany) => {
      this.valid = true;
      this.show = true;
      this.company = payLoad;
    });
  }

  selected(e: any): void {
    this.company.qbDesktopPath = e.name as string;
  }

  save(): void {
    if (this.$refs.form.validate()) {
      var self = this;

      this.loading = true;

      if (this.company.id == -1) {
        this.$store
          .dispatch("company/add", this.company)
          .then((response: ICompany) => {
            self.show = false;
            self.company = {} as ICompany;
            self.loading = false;
          })
          .catch((error: any) => {});
      } else {
        this.$store
          .dispatch("company/update", this.company)
          .then((response: ICompany) => {
            self.show = false;
            self.company = {} as ICompany;
            self.loading = false;
          })
          .catch((error: any) => {});
      }
    }
  }
}
